/**
 * Resolução de tema: servidor (user_settings) é a fonte de escolha explícita;
 * localStorage espelha e inclui migração do `light` auto-gravado pelo loader legado.
 */
import { THEME_STORAGE_KEY, type ThemeMode } from './themeUtils'

export const THEME_USER_CHOICE_KEY = 'synap-theme-user-choice'

const isThemeMode = (value: string | null | undefined): value is ThemeMode =>
  value === 'light' || value === 'dark' || value === 'system'

export const markThemeUserChoice = (): void => {
  try {
    localStorage.setItem(THEME_USER_CHOICE_KEY, '1')
  } catch {
    /* quota / private mode */
  }
}

export const hasThemeUserChoice = (): boolean => {
  try {
    return localStorage.getItem(THEME_USER_CHOICE_KEY) === '1'
  } catch {
    return false
  }
}

export const readStoredThemeMode = (): ThemeMode | null => {
  try {
    const stored = localStorage.getItem(THEME_STORAGE_KEY)
    return isThemeMode(stored) ? stored : null
  } catch {
    return null
  }
}

/** Boot / pré-login: aplica o que está no localStorage sem reescrever. */
export const readBootThemeMode = (): ThemeMode => readStoredThemeMode() ?? 'system'

/**
 * Após `getTheme` com sucesso: servidor sem tema → migra `light` local sem marcador para `system`.
 * Não usar no boot nem quando o servidor retornou `error`.
 */
export const resolveThemeModeAfterServer = (serverTheme: ThemeMode | null): ThemeMode => {
  if (serverTheme) return serverTheme
  const stored = readStoredThemeMode()
  if (hasThemeUserChoice() && stored) return stored
  if (stored === 'light') {
    try {
      localStorage.setItem(THEME_STORAGE_KEY, 'system')
    } catch {
      /* ignore */
    }
    return 'system'
  }
  return stored ?? 'system'
}

export const persistThemeModeLocal = (mode: ThemeMode, fromUser: boolean): void => {
  try {
    localStorage.setItem(THEME_STORAGE_KEY, mode)
    if (fromUser) markThemeUserChoice()
  } catch {
    /* ignore */
  }
}
